import { forwardRef } from "react";
import { styled, View } from "@tamagui/core";
import { ComponentWithViewTracking } from "../../helpers/analytics.mjs";
import { getShadowProps } from "../../helpers/tokens.mjs";
import { jsx } from "react/jsx-runtime";
const BaseBox = styled(View, {
    name: "Box",
    tag: "div",
    variants: {
      shadow: shadowToken => getShadowProps(shadowToken)
    }
  }),
  Box = forwardRef(function ({
    analyticsName,
    trackImpression = !1,
    inViewThreshold,
    ...props
  }, ref) {
    const BaseBoxWithProps = /* @__PURE__ */jsx(BaseBox, {
      ref,
      ...props
    });
    return analyticsName && trackImpression ? /* @__PURE__ */jsx(ComponentWithViewTracking, {
      Component: BaseBoxWithProps,
      analyticsName,
      eventName: "boxViewEvent",
      inViewThreshold,
      ref
    }) : BaseBoxWithProps;
  });
export { Box };